import _ from "lodash";
import { useTranslation } from "react-i18next";
import SelectCampus from "../../../SelectCampus";
import { Select } from "antd";
import { useEffect, useState } from "react";
import { getReverseYears } from "../../../../lib/util";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import Button from "../../../Button";
import { IGetPnLException, IPnLException, IPnLUpdateValue } from "../../../../models/financials.model";
import useAxios from "../../../../hooks/useAxios";
import { getPnLException, updatePnLException } from "../../../../api/financials.api";
import moment from "moment";
import TableEmpty from '../../../common/TableEmpty';
import { IResponse } from "../../../../models/common.api.model";
import useNotification from "../../../../hooks/useNotification";
import Loader from "../../../Loader";
import styled from "styled-components";
import { valueContainerCSS } from "react-select/src/components/containers";

const Block = styled.div`
    .comm-table__area .w-160p {width:160px;}

    .comm-table__area .exceptBorderRight {
        border-right: 2px solid #eaecee !important;
    }

    .comm-table__area .exceptBorderLeft {
        border-left: 2px solid #eaecee !important;
    }

    .comm-table__area tbody tr td:last-child {
        color: #2e4052;
        text-align: center;
        background-color: #fbfbfc;
        font-weight: bold;
    }

    .exthText th{text-align:center !important;}
    .exthMonth {background-color:#eaecee !important; border-right:1px solid #dcdcdc !important;}
`;
const ExceptionList = () => {
    const { t, i18n } = useTranslation();
    const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
    const { successNotification } = useNotification();
    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // SY0005 = 연도
    const SY0005 = commonCodes.find(item => item.commonCode === 'SY0005')?.detailCode;

    const [year, setYear] = useState('');
    const [pnlYear, setPnlYear] = useState('');
    const [pnlNextYear, setPnlNextYear] = useState('');
    const [pnlExceptionRefine, setPnLExceptionRefine] = useState<IPnLException[]>([]);
    const [upExceptionList, setUpExceptionList] = useState<Map<string, IPnLUpdateValue>>(new Map<string, IPnLUpdateValue>());
    const [subTotalData, setSubTotalData] = useState<Map<string, number>>(new Map<string, number>());
    const [totalData, setTotalData] = useState<Map<string, number>>(new Map<string, number>());

    const {data: pnlException, isLoading: isLoading, error: error, execute: executeGetPnL } = useAxios<IGetPnLException>();
    const {data: resData, isLoading: isLoading2, error: error2, execute: executeUpPnL } = useAxios<IResponse<string>>();

    useEffect(() => {
        const defaultDate = moment(new Date());
        setYear(moment(defaultDate).format('YYYY'));
        setPnlYear(moment(defaultDate).format('YYYY'));
        setPnlNextYear(moment(defaultDate).add(1,'year').format('YYYY'));
    },[]);

    useEffect(() => {
        if(pnlException) {
            setUpExceptionList(new Map<string, IPnLUpdateValue>());
            let tempPnLExpense : IPnLException[]  = _.cloneDeep(pnlException.data);
            //소계
            let tempSubTotalData = new Map<string, number>();
            //합계
            let totalMo03 = 0, totalMo04 = 0, totalMo05 = 0, totalMo06 = 0, totalMo07 = 0, totalMo08 = 0, totalMo09 = 0, totalMo10 = 0, totalMo11 = 0, 
            totalMo12 = 0, totalMo01 = 0, totalMo02 = 0, total = 0;
            let tempTotalData = new Map<string, number>();

            tempPnLExpense.forEach((item: IPnLException) => {
                //소계
                item.total = item.mo03 + item.mo04 + item.mo05 + item.mo06 + item.mo07 + item.mo08 + item.mo09 + item.mo10 + item.mo11 + item.mo12 + item.mo01 + item.mo02;
                tempSubTotalData.set(item.detailCode, item.total);
                //합계
                totalMo03 += item.mo03;
                totalMo04 += item.mo04;
                totalMo05 += item.mo05;
                totalMo06 += item.mo06;
                totalMo07 += item.mo07;
                totalMo08 += item.mo08;
                totalMo09 += item.mo09;
                totalMo10 += item.mo10;
                totalMo11 += item.mo11;
                totalMo12 += item.mo12;
                totalMo01 += item.mo01;
                totalMo02 += item.mo02;
                total += item.total;
            });
            
            //합계
            tempTotalData.set('mo03', totalMo03);
            tempTotalData.set('mo04', totalMo04);
            tempTotalData.set('mo05', totalMo05);
            tempTotalData.set('mo06', totalMo06);
            tempTotalData.set('mo07', totalMo07);
            tempTotalData.set('mo08', totalMo08);
            tempTotalData.set('mo09', totalMo09);
            tempTotalData.set('mo10', totalMo10);
            tempTotalData.set('mo11', totalMo11);
            tempTotalData.set('mo12', totalMo12);
            tempTotalData.set('mo01', totalMo01);
            tempTotalData.set('mo02', totalMo02);
            tempTotalData.set('total', total);

            setPnlYear(year);
            setPnlNextYear(moment(year).add(1,'year').format('YYYY'));
            setPnLExceptionRefine(tempPnLExpense);
            setSubTotalData(tempSubTotalData);
            setTotalData(tempTotalData);
        }
    }, [pnlException]);

    useEffect(() => {
        if(resData) {
            if(resData.result === "success") {
                successNotification(t('common.message.save1'));
                
                getException();
            }
        }

    }, [resData]);

    const handleInputChange = (key:string, value:IPnLUpdateValue, detailCode:string, moKey:string) => {
        let tempData = new Map<string, IPnLUpdateValue>(upExceptionList?.entries());
        tempData.set(key, value);
        setUpExceptionList(tempData);

        //sub-total, total 다시 계산
        let tempSubTotalMap = new Map<string, number>(subTotalData?.entries());
        let tempTotalData = _.cloneDeep(totalData);
        let totalAmount = 0;
        
        if(pnlException) {
            let tempPnLExpense : IPnLException[]  = _.cloneDeep(pnlException.data);
            let tempSubTotal : number = 0;
            let tempTotal : number = 0;
            tempPnLExpense.forEach((item: IPnLException) => {
                //소계
                if(item.detailCode === detailCode) {
                    Object.entries(item).map(([key2, value2]) => {
                        if(key2.indexOf('mo') === 0) {
                            if(tempData.has(detailCode+key2)) {
                                tempSubTotal += Number(tempData.get(detailCode + key2)?.amount);
                            } else {
                                tempSubTotal += value2;
                            }
                        }
                    });
                    tempSubTotalMap.set(item.detailCode, tempSubTotal);
                    setSubTotalData(tempSubTotalMap);
                }

                //합계
                Object.entries(item).map(([key2, value2]) => {
                    if(key2 === moKey) {
                        if(tempData.has(item.detailCode+key2)) {
                            tempTotal += Number(tempData.get(item.detailCode + key2)?.amount);
                        } else {
                            tempTotal += value2;
                        }
                    }
                });
            });
            //합계
            tempTotalData.set(moKey ,tempTotal);
            tempTotalData.forEach((value: number, key) => {
                if(key !== 'total') totalAmount += value;
            });
            tempTotalData.set('total' ,totalAmount);
            setTotalData(tempTotalData);
        }
    }

    const getException = () => {
        const campusCode = currentCampus;
        if(year) {
            executeGetPnL(getPnLException(year, campusCode));
        }
    }

    const onSave = async () => {
        const putData = Object.fromEntries(upExceptionList);
        executeUpPnL(updatePnLException(putData));
    }

    return (
        <Block>
            {isLoading2 ? <Loader /> : null}
            <div className="common-search">
                <div className="search-area">
                    <ul className="search-bx">
                        <li>
                            <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
                            <SelectCampus />
                        </li>
                        <li>
                            <label>{t('statistics.refund.placeholder1')}</label> {/* 연도 */}
                            <Select
                            placeholder={t('statistics.refund.placeholder1')}
                            value={year}
                            onChange={value => setYear(value)}
                            >
                            {getReverseYears(SY0005).map(item => (
                                <Select.Option
                                key={item.detailCode}
                                value={item.detailCode}
                                >
                                {item.korName}
                                </Select.Option>
                            ))}
                            </Select>            
                            <div className="comm-btn__area">
                                <Button
                                    className="btn-basic small black"
                                    onClick={() => getException()}
                                    text={t('common.button.search')}
                                />
                            </div>
                        </li>
                        
                    </ul>
                </div>
            </div>
            {pnlExceptionRefine.length ? (
                <>
                    <div className="comm-table__area rowType exthText">
                        <table>
                            <tbody>
                                <tr>
                                    <th className="w-160p">{t('payment.income.tab2') + ' ' + t('payment.income.search2') + '1'}</th>
                                    <th className="exthMonth">{pnlYear}/03</th>
                                    <th className="exthMonth">{pnlYear}/04</th>
                                    <th className="exthMonth">{pnlYear}/05</th>
                                    <th className="exthMonth">{pnlYear}/06</th>
                                    <th className="exthMonth">{pnlYear}/07</th>
                                    <th className="exthMonth">{pnlYear}/08</th>
                                    <th className="exthMonth">{pnlYear}/09</th>
                                    <th className="exthMonth">{pnlYear}/10</th>
                                    <th className="exthMonth">{pnlYear}/11</th>
                                    <th className="exthMonth">{pnlYear}/12</th>
                                    <th className="exthMonth">{pnlNextYear}/01</th>
                                    <th className="exthMonth">{pnlNextYear}/02</th>
                                    <th className="w-150p">{t('cbt.test.column22')}</th>
                                </tr>
                                {
                                    pnlExceptionRefine.map((value, index) => (
                                        <tr key={index}>
                                            <td className="text-left exceptBorderRight">
                                                {i18n.language === 'ko' ? value.detailCodeName : value.detailCodeEngName}
                                            </td>
                                            {
                                                Object.entries(value).map(([key2, value2], index2) => (
                                                    (key2.indexOf('mo') === 0) && (value.detailCode != 'total') &&
                                                    <td  key={index2}>
                                                        <input
                                                            type="number"
                                                            className="form-control input-text text-right"
                                                            value={upExceptionList.has(value.detailCode + key2) ? upExceptionList.get(key2)?.amount : value2}
                                                            onChange={e => {
                                                                if(!e.target.value) {
                                                                    return false;
                                                                }
                                                                if(Number(e.target.value) < 0) {
                                                                    return false;
                                                                }
                                                                
                                                                const tempKey = value.detailCode + key2;
                                                                const tempMonth = key2.replace('mo','');
                                                                const yearMonth = ((tempMonth === '01' || tempMonth === '02') ? value.nextYear : value.year) + tempMonth;
                                                                const tempValue: IPnLUpdateValue = {campusCode:value.campusCode, detailCode:value.detailCode, yearMonth:yearMonth, amount:e.target.value}
                                                                handleInputChange(tempKey, tempValue, value.detailCode, key2);
                                                            }}
                                                        />
                                                    </td>
                                                ))
                                            }
                                            {/* 소계 */}
                                            <td className="text-right exceptBorderLeft">
                                                {'￦' + subTotalData.get(value.detailCode)?.toLocaleString()}
                                            </td>
                                        </tr>
                                    ))
                                }
                                {
                                    /* 합계 */
                                    (totalData) &&
                                        <tr className="tTotal">
                                            <td className="exceptBorderRight">
                                                {t('cbt.test.column22')}
                                            </td>
                                            {
                                                Array.from(totalData.entries()).map(([key,value]) => (
                                                    <td className={"text-right " + (key==='total'&&'exceptBorderLeft')}>{'￦' + value.toLocaleString()}</td>
                                                ))
                                            }
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="comm-bx__space">
                        <div className="comm-btn__area right">
                            <Button
                                className="btn-basic pink"
                                onClick={onSave}
                                text={t('common.button.save')}
                            />
                        </div>
                    </div>
                </>
            ) : (
                <TableEmpty text={t('statistics.appday.text1')} />
            )}
        </Block>
    )
}

export default ExceptionList;